const invite = resolve => require(['@/view/me/invite'], resolve)
const withdrawApply = resolve => require(['@/view/me/withdraw/apply'], resolve)


const pickGoods = resolve => require(['@/view/me/pickGoods/index'], resolve)
const cfmIndex = resolve => require(['@/view/me/cfm/index'], resolve)
const cfmStore = resolve => require(['@/view/me/cfm/store'], resolve)
const cfmGoodsAdd = resolve => require(['@/view/me/cfm/goodsAdd'], resolve)
const pcaIndex = resolve => require(['@/view/me/pca/index'], resolve)
const pcaStore = resolve => require(['@/view/me/pca/store'], resolve)
const pcaGoodsAdd = resolve => require(['@/view/me/pca/goodsAdd'], resolve)
const nfhIndex = resolve => require(['@/view/me/nfh/index'], resolve)
const nfhGoodsAdd = resolve => require(['@/view/me/nfh/goodsAdd'], resolve)
const nfhStore = resolve => require(['@/view/me/nfh/store'], resolve)

const myOrder = resolve => require(['@/view/me/order/index'], resolve)
const ydOrderCancel = resolve => require(['@/view/me/order/cancel'], resolve)
const ydOrderDetail = resolve => require(['@/view/me/order/detail'], resolve)
const ydOrderEvaluate = resolve => require(['@/view/me/order/evaluate'], resolve)
const ydOrderRefundApply = resolve => require(['@/view/me/order/refundApply'], resolve)
const ydOrderRefundDetail = resolve => require(['@/view/me/order/refundDetail'], resolve)
const wuliu = resolve => require(['@/view/me/order/wuliu'], resolve)

const addressIndex = resolve => require(['@/view/me/address/index'], resolve)
const addressAdd = resolve => require(['@/view/me/address/add'], resolve)
const messageList = resolve => require(['@/view/me/message/list'], resolve)
const messageDetail = resolve => require(['@/view/me/message/detail'], resolve)

const setIndex = resolve => require(['@/view/me/set/index'], resolve)
const setNickName = resolve => require(['@/view/me/set/nickName'], resolve)
const setPwd = resolve => require(['@/view/me/set/pwd'], resolve)
const setPhone = resolve => require(['@/view/me/set/phone'], resolve)
const setFeedback = resolve => require(['@/view/me/set/feedback'], resolve)


//我惠中心
const wohui_incomeList = resolve => require(['@/view/me/wohui/income/list'], resolve)
const wohui_regList = resolve => require(['@/view/me/wohui/reg/list'], resolve)
const wohui_recommendList = resolve => require(['@/view/me/wohui/recommend/list'], resolve)
const wohui_collectList = resolve => require(['@/view/me/wohui/collect/list'], resolve)
const wohui_bankCardList = resolve => require(['@/view/me/wohui/bankCard/list'], resolve)
const wohui_bankCardChoose = resolve => require(['@/view/me/wohui/bankCard/choose'], resolve)
const wohui_bankCardAdd = resolve => require(['@/view/me/wohui/bankCard/add'], resolve)
const wohui_giftList = resolve => require(['@/view/me/wohui/gift/list'], resolve)
const wohui_giftGet = resolve => require(['@/view/me/wohui/gift/get'], resolve)
const wohui_prizeList = resolve => require(['@/view/me/wohui/prize/list'], resolve)
const wohui_prizeGet = resolve => require(['@/view/me/wohui/prize/get'], resolve)
const wohui_travelList = resolve => require(['@/view/me/wohui/travel/list'], resolve)
const wohui_travelDetail = resolve => require(['@/view/me/wohui/travel/detail'], resolve)
const wohui_mentorInfo = resolve => require(['@/view/me/wohui/mentor/info'], resolve)
const wohui_mentorSet = resolve => require(['@/view/me/wohui/mentor/set'], resolve)
const wohui_kefu = resolve => require(['@/view/me/wohui/kefu/index'], resolve)
const wohui_help = resolve => require(['@/view/me/wohui/help/index'], resolve)
const wohui_about = resolve => require(['@/view/me/wohui/about/index'], resolve)

const kyd = resolve => require(['@/view/me/kyd/index'], resolve)


const routes = [
  {
    path: '/me/invite',
    name: '/me/invite',
    component: invite,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/withdraw/apply',
    name: '/me/withdraw/apply',
    component: withdrawApply,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/pickGoods/index',
    name: '/me/pickGoods/index',
    component: pickGoods,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/cfm/index',
    name: '/me/cfm/index',
    component: cfmIndex,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/cfm/store',
    name: '/me/cfm/store',
    component: cfmStore,
    meta: {
      // requireAuth: true
    }
  },  {
    path: '/me/cfm/goodsAdd',
    name: '/me/cfm/goodsAdd',
    component: cfmGoodsAdd,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/pca/index',
    name: '/me/pca/index',
    component: pcaIndex,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/pca/store',
    name: '/me/pca/store',
    component: pcaStore,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/pca/goodsAdd',
    name: '/me/pca/goodsAdd',
    component: pcaGoodsAdd,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/nfh/index',
    name: '/me/nfh/index',
    component: nfhIndex,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/nfh/goodsAdd',
    name: '/me/nfh/goodsAdd',
    component: nfhGoodsAdd,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/nfh/store',
    name: '/me/nfh/store',
    component: nfhStore,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/order/index',
    name: '/me/order/index',
    component: myOrder,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/order/cancel',
    name: '/me/order/cancel',
    component: ydOrderCancel,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/order/detail',
    name: '/me/order/detail',
    component: ydOrderDetail,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/order/evaluate',
    name: '/me/order/evaluate',
    component: ydOrderEvaluate,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/order/refundApply',
    name: '/me/order/refundApply',
    component: ydOrderRefundApply,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/order/refundDetail',
    name: '/me/order/refundDetail',
    component: ydOrderRefundDetail,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/order/wuliu',
    name: '/me/order/wuliu',
    component: wuliu,
    meta: {
      // requireAuth: true
    }
  },  {
    path: '/me/address/Index',
    name: '/me/address/Index',
    component: addressIndex,
    meta: {
      // requireAuth: true
    }
  },  {
    path: '/me/address/add',
    name: '/me/address/add',
    component: addressAdd,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/message/list',
    name: '/me/message/list',
    component: messageList,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/message/detail',
    name: '/me/message/detail',
    component: messageDetail,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/set/index',
    name: '/me/set/index',
    component: setIndex,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/me/set/nickName',
    name: '/me/set/nickName',
    component: setNickName,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/me/set/pwd',
    name: '/me/set/pwd',
    component: setPwd,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/me/set/phone',
    name: '/me/set/phone',
    component: setPhone,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/me/set/feedback',
    name: '/me/set/feedback',
    component: setFeedback,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/me/wohui/income/list',
    name: '/me/wohui/income/list',
    component: wohui_incomeList,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/reg/list',
    name: '/me/wohui/reg/list',
    component: wohui_regList,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/recommend/list',
    name: '/me/wohui/recommend/list',
    component: wohui_recommendList,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/collect/list',
    name: '/me/wohui/collect/list',
    component: wohui_collectList,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/bankCard/list',
    name: '/me/wohui/bankCard/list',
    component: wohui_bankCardList,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/bankCard/choose',
    name: '/me/wohui/bankCard/choose',
    component: wohui_bankCardChoose,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/bankCard/add',
    name: '/me/wohui/bankCard/add',
    component: wohui_bankCardAdd,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/gift/list',
    name: '/me/wohui/gift/list',
    component: wohui_giftList,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/gift/get',
    name: '/me/wohui/gift/get',
    component: wohui_giftGet,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/prize/list',
    name: '/me/wohui/prize/list',
    component: wohui_prizeList,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/prize/get',
    name: '/me/wohui/prize/get',
    component: wohui_prizeGet,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/travel/list',
    name: '/me/wohui/travel/list',
    component: wohui_travelList,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/travel/detail',
    name: '/me/wohui/travel/detail',
    component: wohui_travelDetail,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/mentor/info',
    name: '/me/wohui/mentor/info',
    component: wohui_mentorInfo,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/mentor/set',
    name: '/me/wohui/mentor/set',
    component: wohui_mentorSet,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/kefu/index',
    name: '/me/wohui/kefu/index',
    component: wohui_kefu,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/help/index',
    name: '/me/wohui/help/index',
    component: wohui_help,
    meta: {
      // requireAuth: true
    }
  }, {
    path: '/me/wohui/about/index',
    name: '/me/wohui/about/index',
    component: wohui_about,
    meta: {
      // requireAuth: true
    }
  },{
    path: '/me/kyd/index',
    name: '/me/kyd/index',
    component: kyd,
    meta: {
      // requireAuth: true
    }
  },
]
export default {routes}



// WEBPACK FOOTER //
// ./src/router/me.js